(function () {
  window.isolaEmbroideryVersion = "2026-07-18.1";

  var fontStyles = {
    "AKFT071": {
      family: "\"Cinzel Decorative\", Georgia, serif",
      weight: "700",
      spacing: "0.06em",
      transform: "none"
    },
    "Bonne Nuit": {
      family: "\"Cormorant Unicase\", \"Cinzel Decorative\", Georgia, serif",
      weight: "600",
      spacing: "0.035em",
      transform: "uppercase"
    },
    "Buffalo Grass": {
      family: "\"Amatic SC\", \"Handlee\", cursive",
      weight: "700",
      spacing: "0.04em",
      transform: "none"
    },
    "Clementine Rose": {
      family: "\"Lobster Two\", \"Great Vibes\", cursive",
      weight: "700",
      spacing: "0",
      transform: "none"
    },
    "Fenwicke": {
      family: "\"Cormorant Garamond\", Georgia, serif",
      weight: "600",
      spacing: "0.04em",
      transform: "none"
    },
    "Heart Maze Greeting Card": {
      family: "\"Quicksand\", Arial, sans-serif",
      weight: "600",
      spacing: "0.04em",
      transform: "none"
    },
    "Intro Script Redwork": {
      family: "\"MonteCarlo\", \"Great Vibes\", \"Brush Script MT\", cursive",
      weight: "400",
      spacing: "0",
      transform: "none"
    },
    "Isabeau Rose": {
      family: "\"Great Vibes\", \"Brush Script MT\", cursive",
      weight: "400",
      spacing: "0",
      transform: "none"
    },
    "Jinx Noir": {
      family: "\"Handlee\", \"Caveat\", cursive",
      weight: "400",
      spacing: "0.015em",
      transform: "none"
    },
    "Juniper Sky": {
      family: "\"Handlee\", \"Caveat\", cursive",
      weight: "400",
      spacing: "0.015em",
      transform: "none"
    },
    "Kingswell": {
      family: "\"Playfair Display\", Georgia, serif",
      weight: "600",
      spacing: "0.03em",
      transform: "none"
    },
    "Madre Redwork": {
      family: "\"Imperial Script\", \"Great Vibes\", cursive",
      weight: "400",
      spacing: "0",
      transform: "none"
    },
    "Old Time Radio": {
      family: "\"Rye\", Georgia, serif",
      weight: "400",
      spacing: "0.04em",
      transform: "none"
    },
    "Pembroke": {
      family: "\"Bebas Neue\", Arial, sans-serif",
      weight: "400",
      spacing: "0.08em",
      transform: "uppercase"
    },
    "Salt Air": {
      family: "\"Handlee\", \"Caveat\", cursive",
      weight: "400",
      spacing: "0.015em",
      transform: "none"
    },
    "Teeny Tiny Greeting Card": {
      family: "\"Caveat\", \"Comic Sans MS\", cursive",
      weight: "500",
      spacing: "0.06em",
      transform: "none"
    }
  };

  function setFieldState(fields, enabled) {
    fields.forEach(function (field) {
      if (field.hasAttribute("data-embroidery-enabled")) return;
      field.disabled = !enabled;
    });
  }

  function setupEmbroidery(block) {
    if (block.dataset.isolaEmbroideryReady === "true") return;

    var form = block.closest("form");
    var enabledInput = block.querySelector("[data-embroidery-enabled]");
    var fieldsWrap = block.querySelector("[data-embroidery-fields]");
    var layoutInput = block.querySelector("[data-embroidery-layout]");
    var textInput = block.querySelector("[data-embroidery-text]");
    var line2Field = block.querySelector("[data-embroidery-line2-field]");
    var line2Input = block.querySelector("[data-embroidery-line2]");
    var helpText = block.querySelector("[data-embroidery-help]");
    var typeInput = block.querySelector("[data-embroidery-type]");
    var fontInput = block.querySelector("[data-embroidery-font]");
    var positionInput = block.querySelector("[data-embroidery-position]");
    var previewText = block.querySelector("[data-embroidery-preview-text]");
    var previewValueInput = block.querySelector("[data-embroidery-preview-value]");
    var propertyFields = Array.prototype.slice.call(block.querySelectorAll("input, select, textarea"));

    if (!enabledInput || !fieldsWrap || !layoutInput || !textInput || !typeInput || !fontInput || !positionInput || !previewText) return;

    block.dataset.isolaEmbroideryReady = "true";

    function getSelectedColor() {
      return block.querySelector("[data-embroidery-color]:checked");
    }

    function getPlaceholderByType(type) {
      if (type === "Nome") return "Ex: Luiza";
      if (type === "Frase curta") return "Ex: Bons sonhos";
      if (type === "Uma letra") return "Ex: A";
      if (type === "Duas letras") return "Ex: AB";
      return "Ex: ABC";
    }

    function getMaxLengthByType(type) {
      if (type === "Nome") return 16;
      if (type === "Frase curta") return 24;
      if (type === "Uma letra") return 1;
      if (type === "Duas letras") return 2;
      return 3;
    }

    function isLetterType(type) {
      return type === "Tres letras" || type === "Duas letras" || type === "Uma letra";
    }

    function getPreviewFallback(type) {
      if (type === "Nome") return "Luiza";
      if (type === "Frase curta") return "Teste de escrita";
      if (type === "Uma letra") return "A";
      if (type === "Duas letras") return "AB";
      return "ABC";
    }

    function applyFontStyle(fontName) {
      var style = fontStyles[fontName];
      if (!style) return;

      previewText.style.setProperty("--embroidery-font-family", style.family);
      previewText.style.setProperty("--embroidery-font-weight", style.weight);
      previewText.style.setProperty("--embroidery-letter-spacing", style.spacing);
      previewText.style.setProperty("--embroidery-text-transform", style.transform);
    }

    function updatePreview() {
      var selectedColor = getSelectedColor();
      var layout = layoutInput.value;
      var type = typeInput.value;
      var maxLength = getMaxLengthByType(type);
      var text = textInput.value.trim();
      var line2 = line2Input ? line2Input.value.trim() : "";

      textInput.maxLength = maxLength;
      textInput.placeholder = getPlaceholderByType(type);

      if (line2Field) {
        line2Field.hidden = layout !== "Duas linhas";
      }

      if (line2Input) {
        line2Input.disabled = !enabledInput.checked || layout !== "Duas linhas";
      }

      if (helpText) {
        helpText.textContent = isLetterType(type)
          ? "Para monograma, informe as letras na ordem desejada."
          : "O texto sera bordado exatamente como informado.";
      }

      if (text.length > maxLength) {
        text = text.slice(0, maxLength);
        textInput.value = text;
      }

      if (isLetterType(type)) {
        text = text.replace(/[^A-Za-zÀ-ÿ]/g, "").slice(0, maxLength).toUpperCase();
        textInput.value = text;
      }

      var fallbackText = getPreviewFallback(type);

      previewText.textContent = layout === "Duas linhas"
        ? [text || fallbackText, line2 || "Linha 2"].join("\n")
        : text || fallbackText;
      previewText.setAttribute("data-stitch-text", previewText.textContent);
      previewText.style.color = selectedColor ? selectedColor.getAttribute("data-embroidery-color") : "#315f79";
      previewText.dataset.layout = layout;
      previewText.dataset.type = type;
      previewText.dataset.font = fontInput.value;
      previewText.dataset.position = positionInput.value;
      applyFontStyle(fontInput.value);

      if (previewValueInput) {
        previewValueInput.value = enabledInput.checked
          ? [layout, text || fallbackText, line2 || "", type, fontInput.value, selectedColor ? selectedColor.value : "", positionInput.value].join(" | ")
          : "";
      }
    }

    function updateEnabledState() {
      var enabled = enabledInput.checked;
      fieldsWrap.hidden = !enabled;
      setFieldState(propertyFields, enabled);
      enabledInput.disabled = false;
      updatePreview();
    }

    enabledInput.addEventListener("change", updateEnabledState);
    block.addEventListener("input", updatePreview);
    block.addEventListener("change", updatePreview);

    updateEnabledState();
  }

  function initEmbroidery(context) {
    var root = context || document;

    root.querySelectorAll("[data-isola-embroidery]").forEach(setupEmbroidery);
  }

  document.addEventListener("DOMContentLoaded", function () {
    initEmbroidery(document);
  });

  document.addEventListener("shopify:section:load", function (event) {
    initEmbroidery(event.target);
  });

  if (document.readyState !== "loading") {
    document.querySelectorAll("[data-isola-embroidery]").forEach(setupEmbroidery);
  }
})();
